__turbopack_context__.v({
  "layout": "Layout-module-scss-module__Cvqt1a__layout",
});
